/* eslint-disable max-len */
import React from 'react';
function ClearAllOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 12C4 7.03 8.03 3 13 3C17.97 3 22 7.03 22 12C22 16.97 17.97 21 13 21C10.94 21 9.04 20.3 7.52 19.14L8.94 17.7C10.09 18.51 11.49 19 13 19C16.87 19 20 15.87 20 12C20 8.13 16.87 5 13 5C9.13 5 6 8.13 6 12H9L5 16L1 12H4ZM13 10C14.1 10 15 10.9 15 12C15 13.1 14.1 14 13 14C11.9 14 11 13.1 11 12C11 10.9 11.9 10 13 10Z" })));
}
export default ClearAllOutlined;
